import React from 'react'
import Header from '../components/Header'
import Banner from '../components/Banner'
import Footer from '../components/Footer'
import Festival2025Early from "./Festival2025Early";

export default function About() {
    return (
        <React.Fragment>
            <Header />
            <Banner name="  🎭 17. ETHOS ANKARA ULUSLARARASI TİYATRO FESTİVALİ" />
            <section className="ts-intro-content">
                <div className="container">
                    <div className="row">
                       <Festival2025Early/>

                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}
